// src/pages/jewellers/CustomerKitties.js
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../../api";
import Loader from "../../components/Loader";

export default function CustomerKitties() {
  const [kitties, setKitties] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchKitties = async () => {
      try {
        const res = await api.get("/customer-kitties");
        setKitties(res.data);
      } catch (err) {
        console.error("Error fetching kitties:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchKitties();
  }, []);

  if (loading) return <Loader />;

  return (
    <div className="bg-gray-50 p-6 md:p-10">
      {/* Header Section */}
      <div className="flex flex-col sm:flex-row justify-between items-center bg-gradient-to-r from-purple-600 to-indigo-600 text-white rounded-2xl shadow-lg p-6 mb-8">
        <h1 className="text-3xl font-bold flex items-center gap-2">
          💎 Customer Kitties
        </h1>
        <Link
          to="/jewellers/customer-kitties/add"
          className="mt-4 sm:mt-0 bg-white text-purple-600 font-semibold px-5 py-2.5 rounded-lg shadow hover:bg-purple-100 transition-all duration-200"
        >
          + Assign New Kitty
        </Link>
      </div>

      {/* Table Section */}
      <div className="overflow-x-auto bg-white rounded-xl shadow-md border border-gray-200">
        <table className="min-w-full text-sm text-gray-700">
          <thead className="bg-gray-100 text-gray-800 text-sm uppercase font-semibold">
            <tr>
              <th className="px-6 py-3 text-left">Kitty Name</th>
              <th className="px-6 py-3 text-left">Customer</th>
              <th className="px-6 py-3 text-left">Type</th>
              <th className="px-6 py-3 text-left">Status</th>
              <th className="px-6 py-3 text-left">Start Date</th>
              <th className="px-6 py-3 text-left">End Date</th>
              <th className="px-6 py-3 text-center">Actions</th>
            </tr>
          </thead>
          <tbody>
            {kitties.length > 0 ? (
              kitties.map((k, index) => (
                <tr
                  key={k.id}
                  className={`border-b hover:bg-purple-50 transition-colors ${
                    index % 2 === 0 ? "bg-white" : "bg-gray-50"
                  }`}
                >
                  <td className="px-6 py-3 font-medium">{k.kitty_name}</td>
                  <td className="px-6 py-3">{k.customer?.full_name || "—"}</td>
                  <td className="px-6 py-3 capitalize">{k.kitty_type}</td>
                  <td className="px-6 py-3">
                    <span
                      className={`px-3 py-1 rounded-full text-xs font-semibold ${
                        k.status === "active"
                          ? "bg-green-100 text-green-700"
                          : k.status === "paused"
                          ? "bg-red-100 text-red-700"
                          : "bg-yellow-100 text-yellow-700"
                      }`}
                    >
                      {k.status || "—"}
                    </span>
                  </td>
                  <td className="px-6 py-3">{k.start_date ?? "—"}</td>
                  <td className="px-6 py-3">{k.end_date ?? "—"}</td>
                  <td className="px-6 py-3 text-center space-x-2">
                    <Link
                      to={`/jewellers/customer-kitties/${k.id}/view`}
                      className="inline-block bg-green-500 text-white px-3 py-1.5 rounded-md text-xs font-semibold hover:bg-green-600 transition"
                    >
                      View
                    </Link>
                    <Link
                      to={`/jewellers/customer-kitties/${k.id}/edit`}
                      className="inline-block bg-yellow-500 text-white px-3 py-1.5 rounded-md text-xs font-semibold hover:bg-yellow-600 transition"
                    >
                      Edit
                    </Link>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan="9"
                  className="px-6 py-10 text-center text-gray-500 italic"
                >
                  No customer kitties found. Click{" "}
                  <b className="text-purple-600">“Assign New Kitty”</b> to
                  create one.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
